export const destinations = [
  {
    id: 1,
    name: "Design and Architectural Services",
    details:
      "Global Talia Limited guides the creation of structures by developing designs, producing construction documents, managing projects from concept to completion, overseeing construction, and ensuring compliance with regulations. Key services include architectural design, project management, cost estimation, site selection, interior design, and the documentation necessary for construction and permits.",
    image: "/assets/destinations/gtl/design.jpg",
    bigImage: "/assets/destinations/gtl/design.jpg",
    language: "Design",
    currency: "Design",
  },
  {
    id: 2,
    name: "Project Management",
    details:
      "Global Talia Limited plans, coordinates, and controls all aspects of construction projects from inception to completion, ensuring it meets client expectations, budget, and schedule while adhering to quality and safety standards. We manage design, procurement, and the construction phase itself, acting as a central point of communication and oversight for owners, designers, contractors, and other stakeholders.",
    image: "/assets/destinations/gtl/project.jpg",
    bigImage: "/assets/destinations/gtl/project.jpg",
    language: "Project",
    currency: "Project",
  },
  {
    id: 3,
    name: "Building & Construction",
    details:
      "Global Talia Limited manages the entire process of constructing buildings and infrastructure, from initial planning and design to final completion and occupancy. Our core functions include project planning, site preparation, construction, resource management, and ensuring adherence to budgets, schedules, and safety standards to bring a client's vision into a tangible reality.",
    image: "/assets/destinations/gtl/building.jpg",
    bigImage: "/assets/destinations/gtl/building.jpg",
    language: "Building",
    currency: "Building",
  },
  {
    id: 4,
    name: "Consultancy",
    details:
      "Global Talia Limited provides specialized expertise to guide and support clients through every phase of a construction project, from the initial planning and feasibility stages to design, construction, and final delivery. We offer professional advice, project management, cost control, technical guidance, and risk management to ensure projects are completed efficiently, on time, within budget, and to the required quality standards. Essentially, we act as expert advisors to the project owner, ensuring informed decision-making and successful project outcomes.",
    image: "/assets/destinations/gtl/consultancy.jpg",
    bigImage: "/assets/destinations/gtl/consultancy.jpg",
    language: "Consultancy",
    currency: "Consultancy",
  },
  {
    id: 5,
    name: "Materials Supply",
    details:
      "Global Talia Limited procures, manages, and distributes materials needed for construction projects to ensure they are available on-time, within budget, and of the correct quality. We handle a wide range of products, from bulk materials like concrete and steel to specialized items such as roofing and insulation, managing the entire supply chain to keep projects running smoothly and efficiently",
    image: "/assets/destinations/gtl/materials.jpg",
    bigImage: "/assets/destinations/gtl/materials.jpg",
    language: "Materials",
    currency: "Materials",
  },
  {
    id: 6,
    name: "Project Design and Costing",
    details:
      "Global Talia Limited provides expert services to plan the technical aspects of projects and meticulously calculate the associated costs to ensure it is feasible, within budget, and efficiently executed. We handle everything from initial feasibility studies and high-level estimates to detailed material and labour cost breakdowns, resource allocation, risk assessment, and ongoing cost control throughout the project lifecycle. This ensures projects are both technically sound and financially viable.",
    image: "/assets/destinations/gtl/costing.jpg",
    bigImage: "/assets/destinations/gtl/costing.jpg",
    language: "Design",
    currency: "Design",
  },
  {
    id: 7,
    name: "Civil Engineering",
    details:
      "Global Talia Limited specialises on the planning, design, construction, and maintenance of a broad range of public and private infrastructure projects, from roads, bridges, and buildings to dams and water systems. We provide services such as project management, surveying, data analysis, and consulting to ensure projects are safe, efficient, and meet regulatory standards.",
    image: "/assets/destinations/gtl/civil.jpg",
    bigImage: "/assets/destinations/gtl/civil.jpg",
    language: "Civil",
    currency: "Civil",
  },
  {
    id: 8,
    name: "Real Estate Management",
    details:
      "Global Talia Limited facilitates the buying, selling, renting, and management of properties for clients by acting as a liaison between parties, providing market expertise, and handling transactions and legal processes. Our services include connecting buyers and sellers, marketing properties using digital platforms and data analytics, advising on property values and market conditions, managing property operations like rent collection and maintenance for owners, and assisting with the extensive paperwork and legal aspects of real estate transactions.",
    image: "/assets/destinations/gtl/estate.jpg",
    bigImage: "/assets/destinations/gtl/estate.jpg",
    language: "Estate",
    currency: "Estate",
  },
];
